//Cookies in json form
$.cookie.json = true;


var $menuSections = $('.menu-sections'),
	windowWidth = parseInt($(window).width()),
	windowHeight = parseInt($(window).height()),
	mobileBreakpoint = 460,
	userFilters = $('body').hasClass('car-search') ? 'car' : 'tyre',
	currentFilters,
	availableFilters,
	lazyloadPosition = 0,
	resultsCount = 0,
	showClosestLocation = true,
    locationSuccessful = false,
    userLat = '',
    userLon = '';
    
    // If resize, change windowHeight, Width
    document.addEventListener('resize',()=>{
        windowWidth = parseInt($(window).width());
        windowHeight = parseInt($(window).height());
    })

	if ( $('body').hasClass('car-search') ) {
		var searchPage = 'car';
	} else if ( $('body').hasClass('tyre-search') ) {
		var searchPage = 'tyre';
	} else {
		var searchPage = false;
	}



//Navigation element variables
	var $menuSectionParent = $('nav .menu-sections'),
		$sectionSelectionItem = $('nav ul.sections li'),
		$navigations = $('.navigations'),
		$mainNavItem = $('.navigation-main-level li'),
		$subNavItem = $('.navigation-sub-level li');


$(document).ready(function(){

    /*if(document.location.search == '?referrer=autoilves'){
        window.history.pushState(null, null, "/" );
    }*/

    //Autoilves popup
    $('.autoilves-popup-container, .autoilves-popup').click(function(e){
        if(e.target != this) return;
        $('.autoilves-popup-container').fadeOut(200, function(){
            $(this).remove();
        });
    });

    $('.autoilves-popup-container').find('.close').click(function(){
        $(this).parents('.autoilves-popup-container').fadeOut(200, function(){
            $(this).remove();
        });
    });

    //Cookie notification
    var browserCache = localStorage.getItem('browser');

    function createCookie(name,value,days) {
        "use strict";
        var expires = '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            expires = "; expires="+date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = name+"="+value+expires+"; path=/";
    }

    function readCookie(name) {
        "use strict";
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    if ((!browserCache || readCookie('browserN') == 'null') && $.browser != 'undefined'){
        var bv_old = false;
        var dl_browser = '';
        var bv_undefined = false;
        var bv = $.browser.version;
        var bv_rounded = bv.substring(0, bv.indexOf('.'));
             if ($.browser.chrome == true){ bv_old = (bv_rounded < 30) ? true : false; dl_browser = 'https://www.google.com/chrome'; }
        else if ($.browser.msie == true && navigator.userAgent.match(/iemobile/i) != null){ bv_old = (bv_rounded <= 10) ? true : false; dl_browser = 'http://windows.microsoft.com/fi-fi/internet-explorer/download-ie'; }
        else if ($.browser.msie == true && navigator.userAgent.match(/iemobile/i) == null){ bv_old = (bv_rounded < 10) ? true : false; dl_browser = 'http://windows.microsoft.com/fi-fi/internet-explorer/download-ie'; }
        else if ($.browser.mozilla == true && navigator.userAgent.indexOf('Trident') != -1){ bv_old = (bv_rounded < 10) ? true : false; dl_browser = 'http://windows.microsoft.com/fi-fi/internet-explorer/download-ie'; }
        else if ($.browser.mozilla == true && navigator.userAgent.indexOf('Trident') == -1 && navigator.userAgent.indexOf('Edge') == -1){ bv_old = (bv_rounded < 30) ? true : false; dl_browser = 'https://www.mozilla.org/fi/firefox/new/'; }
        else if ($.browser.opera == true){ bv_old = (bv_rounded < 30) ? true : false; dl_browser = 'http://www.opera.com/fi'; }
        else if ($.browser.safari == true){ bv_old = (bv_rounded < 537) || (bv_rounded.length == 4) ? true : false; dl_browser = 'http://www.apple.com/support/mac-apps/safari/'; } // Safari 6.1 ->
        else { bv_undefined = true; dl_browser = 'https://www.google.com/chrome'; }

        var browser_text = !bv_undefined ? ('Lataa uusin versio selaimestasi <a href="'+dl_browser+'" target="_blank">täältä</a>.') : ('Lataa Google Chromen uusin versio <a href="'+dl_browser+'">täältä</a>.');
        if(bv_old == true || bv_undefined == true){ $('#notification-container').prepend('<div class="browser-info">Selaimesi on vanhentunut tai sitä ei välttämättä tueta, joten kaikki sivun toiminnot eivät mahdollisesti toimi toivotulla tavalla. ' + browser_text + '<span class="close">Sulje</span></div>'); }
    }
    $('.browser-info span').click(function(){
        var $self = $(this);
        $self.parent().fadeOut(400, function(){ $self.remove() });
        setTimeout(function(){
            $self.parent().remove();
        }, 400);
        localStorage.setItem('browser', 'browserNotification');
        createCookie('browserN','browserNotification',7);
    });

    if ("geolocation" in navigator) {
        function geoFindMe() {
            function distance(lon1, lat1, lon2, lat2) {
                var R = 6371; // Radius of the earth in km
                var dLat = (lat2-lat1).toRad();  // Javascript functions in radians
                var dLon = (lon2-lon1).toRad();
                var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                        Math.cos(lat1.toRad()) * Math.cos(lat2.toRad()) *
                        Math.sin(dLon/2) * Math.sin(dLon/2);
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
                var d = R * c; // Distance in km
                return Math.round(d);
            }
            if (typeof(Number.prototype.toRad) === "undefined") {
                Number.prototype.toRad = function() {
                    return this * Math.PI / 180;
                }
            }

            var kouvola = {lon: parseFloat($('.store.kouvola').data('lon')), lat: parseFloat($('.store.kouvola').data('lat')), hasBrandService: $('.store.kouvola').hasClass('brand')};
            var kerava = {lon: parseFloat($('.store.kerava').data('lon')), lat: parseFloat($('.store.kerava').data('lat')), hasBrandService: $('.store.kerava').hasClass('brand')};
            var kotka = {lon: parseFloat($('.store.kotka').data('lon')), lat: parseFloat($('.store.kotka').data('lat')), hasBrandService: $('.store.kotka').hasClass('brand')};
            var porvoo = {lon: parseFloat($('.store.porvoo').data('lon')), lat: parseFloat($('.store.porvoo').data('lat')), hasBrandService: $('.store.porvoo').hasClass('brand')};
            var lahti = {lon: parseFloat($('.store.lahti').data('lon')), lat: parseFloat($('.store.lahti').data('lat')), hasBrandService: $('.store.lahti').hasClass('brand')};
            var tampere = {lon: parseFloat($('.store.tampere').data('lon')), lat: parseFloat($('.store.tampere').data('lat')), hasBrandService: $('.store.tampere').hasClass('brand')};
            var hameenlinna = {lon: parseFloat($('.store.hameenlinna').data('lon')), lat: parseFloat($('.store.hameenlinna').data('lat')), hasBrandService: $('.store.hameenlinna').hasClass('brand')};
            var hyvinkaa = {lon: parseFloat($('.store.hyvinkaa').data('lon')), lat: parseFloat($('.store.hyvinkaa').data('lat')), hasBrandService: $('.store.hyvinkaa').hasClass('brand')};
            var hameenlinna_visamaki = {lon: parseFloat($('.store.hameenlinna-visamaki').data('lon')), lat: parseFloat($('.store.hameenlinna-visamaki').data('lat')), hasBrandService: $('.store.hameenlinna-visamaki').hasClass('brand')};
            var hamina = {lon: parseFloat($('.store.hamina').data('lon')), lat: parseFloat($('.store.hamina').data('lat')), hasBrandService: $('.store.hamina').hasClass('brand')};

            function success(position) {
                locationSuccessful = true;

                if ( !$.cookie('userPositionLat') && !$.cookie('userPositionLon') ) {
                    var lat  = position.coords.latitude;
                    var lon = position.coords.longitude;
                    $.cookie('userPositionLat', position.coords.latitude);
                    $.cookie('userPositionLon', position.coords.longitude);
                } else {
                    var lat  = parseFloat($.cookie('userPositionLat'));
                    var lon = parseFloat($.cookie('userPositionLon'));
                }

				userLat = lat;
				userLon = lon;

                var dist_kouvola = distance(lon, lat, kouvola.lon, kouvola.lat),
                    dist_kerava = distance(lon, lat, kerava.lon, kerava.lat),
                    dist_kotka = distance(lon, lat, kotka.lon, kotka.lat),
                    dist_porvoo = distance(lon, lat, porvoo.lon, porvoo.lat),
                    dist_lahti = distance(lon, lat, lahti.lon, lahti.lat),
                    dist_tampere = distance(lon, lat, tampere.lon, tampere.lat),
                    dist_hameenlinna = distance(lon, lat, hameenlinna.lon, hameenlinna.lat),
                    dist_hyvinkaa = distance(lon, lat, hyvinkaa.lon, hyvinkaa.lat),
                    dist_hameenlinna_visamaki = distance(lon, lat, hameenlinna_visamaki.lon, hameenlinna_visamaki.lat),
                    dist_hamina = distance(lon, lat, hamina.lon, hamina.lat),
                    closest = Math.min(dist_kouvola,dist_kerava,dist_kotka,dist_porvoo,dist_lahti,dist_tampere,dist_hameenlinna,dist_hyvinkaa,dist_hameenlinna_visamaki,dist_hamina);

                // If there are brand services defined show closest brand service
                var brandServiceFound = $(".store.brand").length > 0;
                if (brandServiceFound) {
                    var brandServiceDists = [];
                    if (kouvola.hasBrandService) {
                        brandServiceDists.push(dist_kouvola);
                    }
                    if (kerava.hasBrandService) {
                        brandServiceDists.push(dist_kerava);
                    }
                    if (kotka.hasBrandService) {
                        brandServiceDists.push(dist_kotka);
                    }
                    if (porvoo.hasBrandService) {
                        brandServiceDists.push(dist_porvoo);
                    }
                    if (lahti.hasBrandService) {
                        brandServiceDists.push(dist_lahti);
                    }
                    if (tampere.hasBrandService) {
                        brandServiceDists.push(dist_tampere);
                    }
                    if (hameenlinna.hasBrandService) {
                        brandServiceDists.push(dist_hameenlinna);
                    }
                    if (hyvinkaa.hasBrandService) {
                        brandServiceDists.push(dist_hyvinkaa);
                    }
                    if (hameenlinna_visamaki.hasBrandService) {
                        brandServiceDists.push(dist_hameenlinna_visamaki);
                    }
                    if (hamina.hasBrandService) {
                        brandServiceDists.push(dist_hamina);
                    }
                    closest = Math.min.apply(Math, brandServiceDists);
                }

                /*console.log('my_coords: '+'lon('+lon+'), lat('+lat+')');
                console.log('kouvola: '+dist_kouvola+' km');
                console.log('kotka: '+dist_kotka+' km');
                console.log('porvoo: '+dist_porvoo+' km');
                console.log('kerava: '+dist_kerava+' km');
                console.log('lahti: '+dist_lahti+' km');
                console.log('tampere: '+dist_tampere+' km');*/

                $('.store').find('.loading').remove();
                $('.store.loading-closest').remove();
                $('p.distance').show();
                var locations = {
                    kouvola : dist_kouvola,
                    kerava : dist_kerava,
                    kotka : dist_kotka,
                    porvoo : dist_porvoo,
                    lahti : dist_lahti,
                    tampere : dist_tampere,
                    hameenlinna : dist_hameenlinna,
                    hyvinkaa : dist_hyvinkaa,
                    'hameenlinna-visamaki' : dist_hameenlinna_visamaki,
                    hamina : dist_hamina
                };
                $.each(locations, function(i, val) {
                    if(showClosestLocation == true){
                        if (val == closest) {
                            $('.store.'+i).css('opacity', '1').addClass('active');
                            
                            const storeName = $('.store.' + i + ' .store-name').text();
                            
                            if (storeName) {
                                window.visitorLocation = storeName;
                            }
                        }
                        else {
                            $('.store.'+i).css('opacity', '0').removeClass('active');
                        }
                    }
                    $('.store.'+i).children('p.distance').text(val+' km');
                    $('.store.'+i).children('p.distance').attr('data-dist', val);
                });
            };

            function error() {
                // Fail
                $('.store').find('.loading').remove();

                $('.loading-closest').html('<strong>Sijaintiasi ei voitu paikantaa.</strong>');
                setTimeout(function(){
                    $('.loading-closest').fadeOut('slow', function(){
                        $(this).remove();
                        $('.service-locations').each(function(){ $(this).children('.store').first().css('opacity', 1).addClass('active'); });
                    });
                    $('p.distance').hide();
                }, 2000);
            };

            $('.store').children('p.distance').html('<div class="loading"></div>');
            $('.service-locations').append('<div class="store active loading-closest" style="opacity:1;"><div class="loading"></div><strong>Haetaan lähintä toimipistettä...</strong></div>');
            setTimeout(function(){
                if(locationSuccessful == false){
                    $('.loading-closest').html('<strong>Sijaintiasi ei voitu paikantaa.</strong>');
                    setTimeout(function(){
                        if(locationSuccessful == false){
                            $('.loading-closest').fadeOut('slow', function(){
                                $(this).remove();
                                $('.service-locations').each(function(){ $(this).children('.store').first().css('opacity', 1).addClass('active'); });
                            });
                            $('p.distance').hide();
                        }
                    }, 2000);
                }
            }, 2000);

            if ( !$.cookie('userPositionLat') && !$.cookie('userPositionLon') ) {
                navigator.geolocation.getCurrentPosition(success, error);
            } else {
                success();
            }


        }
        geoFindMe();
    } else {
        /* geolocation IS NOT available */
    }

    if($('.noNav').length){ $('.navigations').removeClass('sub'); }




});
global.$menuSections         = $menuSections;
global.windowWidth           = windowWidth;
global.windowHeight          = windowHeight;
global.mobileBreakpoint      = mobileBreakpoint;
global.userFilters           = userFilters;
global.currentFilters        = currentFilters;
global.availableFilters      = availableFilters;
global.lazyloadPosition      = lazyloadPosition;
global.resultsCount          = resultsCount;
global.showClosestLocation   = showClosestLocation;
global.locationSuccessful    = locationSuccessful;
global.userLat               = userLat;
global.userLon               = userLon;
global.$menuSectionParent    = $menuSectionParent;
global.$sectionSelectionItem = $sectionSelectionItem;
global.$navigations          = $navigations;
global.$mainNavItem          = $mainNavItem;
global.$subNavItem           = $subNavItem;
global.searchPage            = searchPage;